// extracted by mini-css-extract-plugin
export default {"paypalWrapper":"_3bygB","paypalInfosLeft":"_1AMCM","paypalImage":"y-NqY","email":"RBp48","link":"VJRmj"};